import { Injectable } from '@angular/core';
import { checkAndUpdateBinding } from '@angular/core/src/view/util';

export interface ChildrenItems {
  state: string;
  name: string;
  type?: string;
}

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  children?: ChildrenItems[];
}

const MENUITEMS = [
  {
    state: 'dashboard',
    name: 'Inicio',
    type: 'link',
    icon: 'home',
  },
  {
    state: 'clients',
    name: 'Clientes',
    type: 'sub',
    icon: 'people',
    children: [
      {state: 'index', name: 'Clientes'},
      {state: 'states', name: 'Estados'},
      {state: 'cities', name: 'Ciudades'},
      {state: 'price', name: 'Valor envio'}
    ]
  },
  {
    state: 'providers',
    name: 'Proveedores',
    type: 'sub',
    icon: 'people',
    children: [
      {state: 'index', name: 'Proveedores'},
      {state: 'whouses', name: 'Bodegas'},
    ]
  },
  {
    state: 'products',
    name: 'Productos',
    type: 'sub',
    icon: 'apps',
    children: [
      {state: 'index', name: 'Productos'},
      {state: 'update', name: 'Actualización'},
      {state: 'inventories', name: 'Inventarios'},
      {state: 'cupons', name: 'Cupones'},
      {state: 'categories', name: 'Categorias'},
      {state: 'properties', name: 'Atributos'},
      {state: 'specifications', name: 'Especificaciónes'},
    ]
  },
  {
    state: 'sales',
    name: 'Ventas',
    type: 'sub',
    icon: 'attach_money',
    children: [
      {state: 'index', name: 'Ventas'},
      {state: 'return', name: 'Devoluciones'},      
    ]
  },
  {
    state: 'marketing',
    name: 'Marketing',
    type: 'link',
    icon: 'assignment',
  },
  {
    state: 'reports', 
    name: 'Reportes',
    type: 'sub',
    icon: 'assignment',
    children: [
      {state: 'inventary', name: 'Inventario'},
      {state: 'prodsale', name: 'Venta de producto'},      
    ]
  },
  {
    state: 'config',
    name: 'Config',
    type: 'link',
    icon: 'build',
  },
  {
    state: 'auth',
    name: 'Salir',
    type: 'link',
    icon: 'exit_to_app'
  }
];

@Injectable()
export class MenuItems {
  getAll(): Menu[] {
    // let menus = this.generalService.menus;
    // console.log(menus);
    /*
    this.generalService.chkAccess(1);
    this.chk = this.generalService.useraccess;
    if ( this.chk === true) {
      this.menu ={
        state: 'cms',
        name: 'CMS',
        type: 'sub',
        icon: 'text_format',
        children: [
          {state: 'index', name: 'Contenidos'},
          {state: 'menu', name: 'Menu'},
          {state: 'banners', name: 'Banner ppal'},
          {state: 'bannersa', name: 'Banners'},
          {state: 'news', name: 'Novedades'},
          {state: 'benefic', name: 'Beneficios'},
          {state: 'clients', name: 'Clientes'}
        ]
      };
      MENUITEMS.push(this.menu);
    }

    this.generalService.chkAccess(2);
    this.chk = this.generalService.useraccess;
    if ( this.chk === true) {
      this.menu = {
        state: 'users',
        name: 'Usuarios',
        type: 'link',
        icon: 'account_circle'
      };
      MENUITEMS.push(this.menu);
    }
    */
    return MENUITEMS;
  }
  add(menu: Menu) {
    // MENUITEMS.push(menu);
  }
}



// WEBPACK FOOTER //
// /home/estandar/web/tuhogaronline.tk/public_html/adminTHO/src/app/helpers/menu/menu-items/menu-items.ts